var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurplusResourcesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3521 10.6936C20.0547 10.2947 18.8564 10.594 17.1597 11.093C16.6606 11.1931 16.1616 11.492 15.6621 11.8914C15.3628 12.1907 15.063 12.3904 15.063 12.5906C15.063 13.3889 16.8603 14.2869 19.3555 14.1877C21.0522 14.1877 23.4482 13.5886 23.5479 12.6902C23.7476 11.7918 22.3501 10.9929 21.3521 10.6936Z",
    fill: "#203563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.050293 19.0345C0.549803 46.8846 41.2769 47.4832 39.48 20.6316C41.5762 -5.52167 4.04345 -7.21894 0.050293 19.0345ZM25.7046 14.4422C25.7046 14.4422 26.1035 30.6136 24.0073 30.5135C12.3286 31.0125 15.2231 34.0076 13.9258 14.8416C5.93994 9.55108 26.0039 6.25714 27.0024 12.5457C27.0024 13.1448 26.5029 13.8431 25.7046 14.4422Z",
    fill: "#203563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurplusResourcesIcon);
export default __webpack_public_path__ + "static/media/surplus-resources-icon.68301a671ecd59262f1eb68164cec33b.svg";
export { ForwardRef as ReactComponent };